var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsiscircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 92.5300 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2402 4.15039C68.0176 4.15039 85.6934-13.4766 85.6934-35.2539C85.6934-57.0312 68.0176-74.6582 46.2402-74.6582C24.5117-74.6582 6.83594-57.0312 6.83594-35.2539C6.83594-13.4766 24.5117 4.15039 46.2402 4.15039ZM46.2402-3.27148C28.5645-3.27148 14.3066-17.5781 14.3066-35.2539C14.3066-52.9297 28.5645-67.2363 46.2402-67.2363C63.916-67.2363 78.2227-52.9297 78.2227-35.2539C78.2227-17.5781 63.916-3.27148 46.2402-3.27148Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.209-29.4922C67.3828-29.4922 69.9707-32.0801 69.9707-35.2539C69.9707-38.4277 67.3828-41.0645 64.209-41.0645C60.9863-41.0645 58.3984-38.4277 58.3984-35.2539C58.3984-32.0801 60.9863-29.4922 64.209-29.4922Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1914-29.4922C49.4141-29.4922 52.002-32.0801 52.002-35.2539C52.002-38.4277 49.4141-41.0645 46.1914-41.0645C43.0176-41.0645 40.4297-38.4277 40.4297-35.2539C40.4297-32.0801 43.0176-29.4922 46.1914-29.4922Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2227-29.4922C31.3965-29.4922 34.0332-32.0801 34.0332-35.2539C34.0332-38.4277 31.3477-41.0645 28.2227-41.0645C25.0488-41.0645 22.4609-38.4277 22.4609-35.2539C22.4609-32.0801 25.0488-29.4922 28.2227-29.4922Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsiscircle);
export default __webpack_public_path__ + "static/media/ellipsis.circle.63c8c0cd93c709334fdd7c2d7ea0a6ec.svg";
export { ForwardRef as ReactComponent };